import { ref } from 'vue';

export const SupplierAssignmentPaths = {
  Root: '/supplier-assignment',
  Details: '/supplier-assignment/details',
} as const;

export const ActiveStatus = {
  Active: { id: 1, label: 'Aktiv' },
  Inactive: { id: 0, label: 'Inaktiv' },
} as const;

export const ActiveStatusFilterValues = ref<{ id: number; name: string }[]>([
  { id: ActiveStatus.Inactive.id, name: ActiveStatus.Inactive.label },
  { id: ActiveStatus.Active.id, name: ActiveStatus.Active.label },
]);

export enum ChargeType {
  VL = 1,
  ZL = 2,
  HL = 3,
  DL = 4,
  SU_ZL = 100,
  SU_HL = 101,
}

export const HL_LOAD_LOCATION_DESC = 'Hauptlauf';
